<div class="modal-backdrop fade" *ngIf="isThankyouVisible" [class.show]="isThankyouVisible"></div>
<div class="modal fade show" [class.displayFlex]="isThankyouVisible">
  <div class="modal-dialog thankyou-modal">
    <div class="modal-content">

      <section class="thankyou-modal-section">
        <img class="img-fluid" src="https://d1tiqtcifmy0l7.cloudfront.net/prod/icons/thankyouPopupImg.svg" alt="">
        <a class="thankyou-modal-close" (click)="closeModal();"><i
            class="sprite-img-header-footer white-circle-cross"></i></a>
        <div class="thankyou-content">
          <h2>Thank You !</h2>
          <p>Thank you for showing interest. Please check your email, and our tender team will reach out to you shortly.
          </p>

        </div>

        <div class="thankyou-footer">
          <h3>10X Faster App Get the improved Experience.</h3>
          <a href="https://play.google.com/store/apps/details?id=com.moglix.tender&hl=en" target="_blank">
            <img src="./assets/images/googlePlayBadge.webp" alt="">
          </a>
        </div>
      </section>
    </div>
  </div>
</div>